export default function() {
	$.ajax({
    type: 'get',
    url: '/assets/img/sprite.svg'
  }).done(function(data) {
    let svg = $(data).find('svg');
    $('body').prepend(svg);
  });
}
